document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.happy-customers-reviewers-blocks');
  var showMoreBtn = document.querySelector('.happy-customers-reviewers-show-more');
  if (!container || !showMoreBtn) return;

  var mqlDesktop = window.matchMedia('(min-width: 1440px)');
  var BATCH_SIZE = mqlDesktop.matches ? 6 : 2;
  function updateBatchSize(e) {
    BATCH_SIZE = (e.matches ? 6 : 2);
  }
  if (typeof mqlDesktop.addEventListener === 'function') {
    mqlDesktop.addEventListener('change', updateBatchSize);
  } else if (typeof mqlDesktop.addListener === 'function') {
    // Safari fallback
    mqlDesktop.addListener(updateBatchSize);
  }

  var reviews = [];
  var renderedCount = 0;

  function createReviewNode(review) {
    var block = document.createElement('div');
    block.className = 'happy-customers-reviewers-block';

    var left = document.createElement('div');
    left.className = 'happy-customers-reviewers-block-left';

    var nameRow = document.createElement('div');
    nameRow.className = 'happy-customers-reviewers-block-name';

    var nameP = document.createElement('p');
    nameP.textContent = review.name || '';
    var stars = document.createElement('img');
    stars.src = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/all-red-stars.svg?v=1762523549';
    stars.alt = '';

    nameRow.appendChild(nameP);
    nameRow.appendChild(stars);
    left.appendChild(nameRow);

    var descr = document.createElement('p');
    descr.className = 'happy-customers-reviewers-block-description';
    descr.textContent = review.description || '';
    left.appendChild(descr);

    var imgMobile = document.createElement('img');
    imgMobile.className = 'happy-customers-reviewers-block-image mobile-only';
    imgMobile.src = review.photo || '';
    imgMobile.alt = '';
    left.appendChild(imgMobile);

    var right = document.createElement('div');
    right.className = 'happy-customers-reviewers-block-right desktop-only';
    var imgDesktop = document.createElement('img');
    imgDesktop.className = 'happy-customers-reviewers-block-image';
    imgDesktop.src = review.photo || '';
    imgDesktop.alt = '';
    right.appendChild(imgDesktop);

    block.appendChild(left);
    block.appendChild(right);
    return block;
  }

  function renderNext(count) {
    var nextSlice = reviews.slice(renderedCount, renderedCount + count);
    if (!nextSlice.length) return;
    var frag = document.createDocumentFragment();
    nextSlice.forEach(function (r) {
      frag.appendChild(createReviewNode(r));
    });
    container.appendChild(frag);
    renderedCount += nextSlice.length;
    if (renderedCount >= reviews.length) {
      showMoreBtn.disabled = true;
      showMoreBtn.style.display = 'none';
    }
  }

  function init(data) {
    reviews = Array.isArray(data) ? data : [];
    // Clear any placeholder blocks before rendering real data
    container.innerHTML = '';
    renderNext(BATCH_SIZE);
  }

  showMoreBtn.addEventListener('click', function () {
    renderNext(BATCH_SIZE);
  });

  fetch('https://www.perlahelsa.com/cdn/shop/t/1/assets/reviewers.json', { cache: 'no-store' })
    .then(function (res) { return res.json(); })
    .then(function (data) { init(data); })
    .catch(function () {
      // If fetch fails, keep existing placeholder (do nothing)
    });
});


